import Splide from '@splidejs/splide';
import { Translations } from '../utils';
import './obbligazioni-slider.scss';

export class ObbligazioniSlider {
  constructor() {
    this.el = document.querySelector('.js-obbligazioni-slider');
    if (!this.el) return;

    this.init();
  }

  init() {
    const splide = new Splide(this.el, {
      type: 'slide',
      arrows: true,
      pagination: false,
      gap: '24px',
      perPage: 4,
      focus: 0,
      destroy: false,
      drag: true,
      breakpoints: {
        992: {
          perPage: 2.2,
        },
        767: {
          perPage: 1.2,
        },
      },
      i18n: Translations.getSplideI18n(),
    });

    splide.mount();

    const prev = this.el.querySelector('.splide__arrow--prev');
    const next = this.el.querySelector('.splide__arrow--next');
    const updateArrows = () => {
      if (!window.matchMedia('(min-width: 992px)').matches) return;
      const { index } = splide;
      const last = splide.length - splide.options.perPage;

      // Se sono all’ultima slide disabilito next
      if (index >= last) {
        next.classList.add('is-disabled');
      } else {
        next.classList.remove('is-disabled');
      }

      if (splide.length <= splide.options.perPage) {
        prev.classList.add('is-removed');
        next.classList.add('is-removed');
      }
    };

    // primo chek al caricamento
    updateArrows();
    // secondo check al cambio slide
    splide.on('mounted move', updateArrows);
  }
}
